module.exports = __webpack_public_path__ + "img/vps5.33cc1f3.png";